import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { ContactChatRoomQuery } from "./query";

type Props = {
	hotelID: string;
	contactID: string;
};

export const useFetchContactQuery = ({ hotelID, contactID }: Props) => {
	return useCustomSuspenseQuery(ContactChatRoomQuery, {
		variables: {
			hotelID,
			contactID,
		},
	});
};
